// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"555":"18e756f0","670":"c20e5ce8"}[chunkId] + ".chunk.css";
};